import { manhattanDistance } from "flatland/src/distance";
import Entity from "./entity";
import Glyphs from "../glyphs";
import Speed from "./speed";
import Mass from "./mass";
import Health from "./health";
import Equipment from "./equipment";
import Weapons from "./weapons";
import Statblock from "./statblock";
import Description from "./description";
import * as behaviour from "./behaviour";

class GorgonGiantSense {
  constructor() {
    this.awakened = false;
  }

  isEnemy() {
    return true;
  }

  bumpFrom(entity) {
    return true;
  }

  takeTurn(stage) {
    if (stage.isVisible(this.owner.x, this.owner.y)) {
      this.awakened = true;
      const attackDistance = manhattanDistance(this.owner, stage.player);

      if (attackDistance <= 10) {
        this.owner.glyph = Glyphs.GorgonGiantAttack;
        stage.player.glyph = Glyphs.PlayerGiantGaze;

        // Petrifying gaze attack
        stage.player.gazeFrom(this.owner, attackDistance);
      } else {
        this.owner.glyph = Glyphs.GorgonGiant;
        stage.player.glyph = Glyphs.Player;
      }

      // Double attacks when player is adjacent in any tile
      behaviour.meleeCharge(this.owner, stage.player, stage);

    } else {
      if (this.awakened) {
        behaviour.meleeCharge(this.owner, stage.player, stage);
      } else {
        behaviour.drunkenWalk(this.owner, stage);
      }

      this.owner.glyph = Glyphs.GorgonGiant;
      stage.player.glyph = Glyphs.Player;
    }
  }
}

class Giant {
  static spawn() {
    return new Entity(null, null, Glyphs.GorgonGiant, "Gorgon Giant", {
      description: new Description("You try to catch a glimpse of the terrifying bull-headed monster without looking at its eyes."),
      mass: new Mass(Mass.Large),
      speed: new Speed(7),
      health: new Health(80),
      sense: new GorgonGiantSense(),
      stats: new Statblock(20, 8, 20),
      equipment: new Equipment(Weapons.giantFlail())
    });
  }
}

export default Giant;
